import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/switch-horizontal-02.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M15.293 12.293C15.6591 11.9269 16.2381 11.9043 16.6309 12.2247L16.707 12.293L20.707 16.293C21.0976 16.6835 21.0976 17.3166 20.707 17.7071L16.707 21.7071C16.3165 22.0976 15.6835 22.0976 15.293 21.7071C14.9024 21.3166 14.9024 20.6835 15.293 20.293L17.5859 18H4C3.44772 18 3 17.5523 3 17C3 16.4478 3.44772 16 4 16H17.5859L15.293 13.7071L15.2246 13.6309C14.9043 13.2381 14.9269 12.6591 15.293 12.293ZM7.29297 2.29302C7.68349 1.90249 8.31651 1.90249 8.70703 2.29302C9.09756 2.68354 9.09756 3.31655 8.70703 3.70708L6.41406 6.00005H20C20.5523 6.00005 21 6.44776 21 7.00005C21 7.55233 20.5523 8.00005 20 8.00005H6.41406L8.70703 10.293L8.77539 10.3692C9.09574 10.762 9.07315 11.341 8.70703 11.7071C8.34092 12.0732 7.76191 12.0958 7.36914 11.7754L7.29297 11.7071L3.29297 7.70708C2.90244 7.31655 2.90244 6.68354 3.29297 6.29302L7.29297 2.29302Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as SwitchHorizontal02Icon };
